var _style, _rect, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgRecipeIconDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 44.9 36.6",
    style: {
      enableBackground: "new 0 0 44.9 36.6"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FFFFFF;}\r\n")), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0.2,
    className: "st0",
    width: 44.8,
    height: 36.3
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M33.1,28.2V5c0-0.8-0.7-1.5-1.5-1.5H13.4c-0.9,0-1.5,0.7-1.5,1.5v1.5v21.6v2.3c0,0.9,0.7,1.5,1.5,1.5h18.2 c0.6,0,1.1-0.3,1.3-0.8H14.9c-0.8,0-1.5-0.7-1.5-1.5h18.2C32.4,29.8,33.1,29.1,33.1,28.2z M17.1,24.2c-0.3,0.3-0.7,0.3-1,0 c-0.3-0.3-0.3-0.7,0-1l4.4-4.4l1,1L17.1,24.2z M27.8,24.2c-0.3,0.3-0.7,0.3-1,0l-7.5-7.5c0,0,0-0.1-0.1-0.1c-1.1,0.5-2.6,0.1-3.8-1 c-1.4-1.4-1.7-3.3-0.6-4.4c1-1,3-0.8,4.4,0.6c1.2,1.2,1.5,2.7,1,3.8c0,0,0.1,0,0.1,0.1l7.5,7.5C28.1,23.5,28.1,24,27.8,24.2z  M30.6,13.5l-3.2,3.2c0,0-0.1,0-0.1,0.1c-1.1,1-2.2,1-3.1,0.4c0,0,0,0,0,0.1l-0.7,0.7l-1-1l0.7-0.7c0,0,0,0,0.1,0 c-0.6-0.9-0.6-2,0.4-3.1c0,0,0-0.1,0.1-0.1l3.2-3.2c0.1-0.1,0.4-0.1,0.5,0c0.1,0.1,0.1,0.4,0,0.5l-3.1,3.1l0.5,0.5l3.1-3.1 c0.1-0.1,0.4-0.1,0.5,0c0.1,0.1,0.1,0.4,0,0.5l-3.1,3.1l0.5,0.5l3.1-3.1c0.1-0.1,0.4-0.1,0.5,0s0.1,0.4,0,0.5l-3.1,3.1L27,16 l3.1-3.1c0.1-0.1,0.4-0.1,0.5,0C30.7,13.1,30.7,13.3,30.6,13.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecipeIconDefault);
export default __webpack_public_path__ + "static/media/RecipeIconDefault.4f3f7d25aae048aff4f9a0fae0b09dd5.svg";
export { ForwardRef as ReactComponent };